/*
 * Copyright © 2024 Opera Norway AS. All rights reserved.
 *
 * This file is an original work developed by Opera.
 */

import React from 'react';

import {useMessagingService} from './MessagingServiceContext';
import ToggleTile from './components/ToggleTile';
import {RamLimiterInfo} from './FeatureInformation';
import FeatureUpdateMessage from './Messages';

import headerIcon from './img/limiterTile/ramLimiterTitle.svg';
import mainDisabledIcon from './img/limiterTile/ramLimiterDisabledMain.svg';
import mainEnabledIcon from './img/limiterTile/ramLimiterEnabledMain.svg';

const RamLimiterTile = props => {
  const {updateFeatureState, sendMessageToExtension} = useMessagingService();

  const handleToggle = newState => {
    updateFeatureState(RamLimiterInfo.id, newState);
    const message = new FeatureUpdateMessage(RamLimiterInfo.id, newState);
    sendMessageToExtension(message);
  };

  return (
    <ToggleTile
      title={RamLimiterInfo.label}
      icon={headerIcon}
      mainIconDisabled={mainDisabledIcon}
      mainIconEnabled={mainEnabledIcon}
      statusText={{enabled: 'ENABLED', disabled: 'DISABLED'}}
      isEnabled={props.enabled}
      onToggle={handleToggle}
    />
  );
};

export default RamLimiterTile;
